import { Box } from '@mui/material';

import { HALE_DEFAULT_LOGO_URL } from '../../../theme/brands/hale.config';

const HaleLogo = () => (
  <Box sx={{ mb: { xs: 0, md: 1 } }}>
    <Box
      component="img"
      src={HALE_DEFAULT_LOGO_URL}
      alt="Hale Education Group"
      sx={{
        height: { xs: '4rem', md: '5rem' },
        width: 'auto',
        objectFit: 'contain',
      }}
    />
  </Box>
);

export default HaleLogo;
